// Generated by Melange

import * as Stdlib__List from "melange/list.js";
import * as Stdlib__String from "melange/string.js";

function initial(request_id) {
  return {
    request_id,
    target: undefined,
    accounts: /* [] */ 0,
    account_page: undefined,
    install_url: "",
    account: undefined,
    repositories: /* [] */ 0,
    repository_page: undefined,
    repository: undefined,
    name: "",
    branch: "",
    loading: true,
    pending: false
  };
}

function for_project(request_id, project_id, version, branch) {
  const init = initial(request_id);
  return {
    request_id: init.request_id,
    target: {
      project_id,
      version
    },
    accounts: init.accounts,
    account_page: init.account_page,
    install_url: init.install_url,
    account: init.account,
    repositories: init.repositories,
    repository_page: init.repository_page,
    repository: init.repository,
    name: init.name,
    branch,
    loading: init.loading,
    pending: init.pending
  };
}

function stage(t) {
  const match = t.account;
  const match$1 = t.repository;
  if (match !== undefined) {
    if (match$1 !== undefined) {
      return /* Confirm */ 2;
    } else {
      return /* Repositories */ 1;
    }
  } else {
    return /* Accounts */ 0;
  }
}

function update(t, account) {
  if (/* tag */ typeof account !== "object" && typeof account !== "function") {
    switch (account) {
      case /* Back */ 4 :
        if (t.repository !== undefined) {
          return {
            request_id: t.request_id,
            target: t.target,
            accounts: t.accounts,
            account_page: t.account_page,
            install_url: t.install_url,
            account: t.account,
            repositories: t.repositories,
            repository_page: t.repository_page,
            repository: undefined,
            name: t.name,
            branch: t.branch,
            loading: t.loading,
            pending: t.pending
          };
        } else {
          return {
            request_id: t.request_id,
            target: t.target,
            accounts: t.accounts,
            account_page: t.account_page,
            install_url: t.install_url,
            account: undefined,
            repositories: t.repositories,
            repository_page: t.repository_page,
            repository: t.repository,
            name: t.name,
            branch: t.branch,
            loading: false,
            pending: t.pending
          };
        }
      case /* Loading */ 6 :
        return {
          request_id: t.request_id,
          target: t.target,
          accounts: t.accounts,
          account_page: t.account_page,
          install_url: t.install_url,
          account: t.account,
          repositories: t.repositories,
          repository_page: t.repository_page,
          repository: t.repository,
          name: t.name,
          branch: t.branch,
          loading: true,
          pending: t.pending
        };
      case /* Pending */ 7 :
        return {
          request_id: t.request_id,
          target: t.target,
          accounts: t.accounts,
          account_page: t.account_page,
          install_url: t.install_url,
          account: t.account,
          repositories: t.repositories,
          repository_page: t.repository_page,
          repository: t.repository,
          name: t.name,
          branch: t.branch,
          loading: t.loading,
          pending: true
        };
      case /* Failed */ 8 :
        return {
          request_id: t.request_id,
          target: t.target,
          accounts: t.accounts,
          account_page: t.account_page,
          install_url: t.install_url,
          account: t.account,
          repositories: t.repositories,
          repository_page: t.repository_page,
          repository: t.repository,
          name: t.name,
          branch: t.branch,
          loading: false,
          pending: false
        };
      default:
        return t;
    }
  } else {
    switch (account.TAG) {
      case /* Accounts_loaded */ 2 :
        return {
          request_id: t.request_id,
          target: t.target,
          accounts: account._0,
          account_page: account._1,
          install_url: account._2,
          account: t.account,
          repositories: t.repositories,
          repository_page: t.repository_page,
          repository: t.repository,
          name: t.name,
          branch: t.branch,
          loading: false,
          pending: t.pending
        };
      case /* Choose_account */ 3 :
        return {
          request_id: t.request_id,
          target: t.target,
          accounts: t.accounts,
          account_page: t.account_page,
          install_url: t.install_url,
          account: account._0,
          repositories: /* [] */ 0,
          repository_page: undefined,
          repository: undefined,
          name: t.name,
          branch: t.branch,
          loading: true,
          pending: t.pending
        };
      case /* Repositories_loaded */ 4 :
        return {
          request_id: t.request_id,
          target: t.target,
          accounts: t.accounts,
          account_page: t.account_page,
          install_url: t.install_url,
          account: t.account,
          repositories: account._0,
          repository_page: account._1,
          repository: t.repository,
          name: t.name,
          branch: t.branch,
          loading: false,
          pending: t.pending
        };
      case /* Repository_selected */ 6 :
        const repository = account._0;
        const name = Stdlib__List.hd(Stdlib__List.rev(Stdlib__String.split_on_char(/* '/' */47, repository.full_name)));
        return {
          request_id: account._1,
          target: t.target,
          accounts: t.accounts,
          account_page: t.account_page,
          install_url: t.install_url,
          account: t.account,
          repositories: t.repositories,
          repository_page: t.repository_page,
          repository: repository,
          name,
          branch: t.branch,
          loading: false,
          pending: t.pending
        };
      case /* Name */ 7 :
        return {
          request_id: t.request_id,
          target: t.target,
          accounts: t.accounts,
          account_page: t.account_page,
          install_url: t.install_url,
          account: t.account,
          repositories: t.repositories,
          repository_page: t.repository_page,
          repository: t.repository,
          name: account._0,
          branch: t.branch,
          loading: t.loading,
          pending: t.pending
        };
      case /* Branch */ 8 :
        return {
          request_id: t.request_id,
          target: t.target,
          accounts: t.accounts,
          account_page: t.account_page,
          install_url: t.install_url,
          account: t.account,
          repositories: t.repositories,
          repository_page: t.repository_page,
          repository: t.repository,
          name: t.name,
          branch: account._0,
          loading: t.loading,
          pending: t.pending
        };
      default:
        return t;
    }
  }
}

function can_connect(t) {
  if (stage(t) === /* Confirm */ 2 && !t.pending && !t.loading && (t.target !== undefined || Stdlib__String.trim(t.name) !== "")) {
    if (t.target === undefined) {
      return true;
    } else {
      return Stdlib__String.trim(t.branch) !== "";
    }
  } else {
    return false;
  }
}

export {
  initial,
  for_project,
  stage,
  update,
  can_connect,
}
/* No side effect */
